import { render } from "./ImageNodeView.vue?vue&type=template&id=1abf0866"
import script from "./ImageNodeView.vue?vue&type=script&lang=js"
export * from "./ImageNodeView.vue?vue&type=script&lang=js"

import "./ImageNodeView.vue?vue&type=style&index=0&id=1abf0866&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__